import React, { FC, ReactChild } from 'react';
import { barsContainerStyles, containerStyles, plugStyles } from './styles.css';

export type MobileHeaderProps = {
  leftSlot?: ReactChild;
};

const MobileHeader: FC<MobileHeaderProps> = ({ leftSlot }) => (
  <div className={containerStyles}>
    <div className={barsContainerStyles}>
      <svg viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg" width="18" height="18" style={{ fill: '#fff' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11a1 1 0 0 0 1 1h16a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1Zm0-5a1 1 0 0 0 1 1h16a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1Zm1-6a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H1Z"
        ></path>
      </svg>
    </div>

    <img src="assets/images/logo-mobile-min.png" height="35px" width="89px" />

    {leftSlot || <div className={plugStyles} />}
  </div>
);

export default MobileHeader;
